import { useEffect } from 'react';

export const WORKSPACE_NATIVE_SECTIONS = [
  { id: 'overview', label: 'Organisation', sfSymbol: 'building.2' },
  { id: 'trade-profile', label: 'Trade profile', sfSymbol: 'building.columns' },
  { id: 'sales', label: 'Sales', sfSymbol: 'doc.text' },
  { id: 'purchase-orders', label: 'Purchase orders', sfSymbol: 'shippingbox' },
  { id: 'subscription', label: 'Subscription', sfSymbol: 'creditcard' },
  { id: 'membership', label: 'Membership', sfSymbol: 'star' },
  { id: 'stripe-invoices', label: 'Invoices', sfSymbol: 'doc.text' },
  { id: 'credit', label: 'Credit report', sfSymbol: 'shield' },
  { id: 'integrations', label: 'Plugins', sfSymbol: 'powerplug' },
  { id: 'documents', label: 'Documents', sfSymbol: 'folder' },
  { id: 'resource-library', label: 'Resource Library', sfSymbol: 'books.vertical.fill' },
  { id: 'users', label: 'Users', sfSymbol: 'person.2' },
  { id: 'activity', label: 'Activity', sfSymbol: 'chart.bar' },
];

export function hasNativeWorkspaceSectionMenu(): boolean {
  if (typeof window === 'undefined') return false;
  const bridge = (window as unknown as {
    QuantisNativeBridge?: { hasNativeWorkspaceSectionMenu?: boolean | (() => boolean) };
  }).QuantisNativeBridge;
  const capability = bridge?.hasNativeWorkspaceSectionMenu;
  try {
    return typeof capability === 'function' ? capability.call(bridge) === true : capability === true;
  } catch { return false; }
}

export function useNativeWorkspaceSectionMenu(
  activeTab: string,
  onSection: (section: string) => void,
  onClose: () => void,
  eligible: boolean,
): boolean {
  const enabled = eligible && hasNativeWorkspaceSectionMenu();
  useEffect(() => {
    if (!enabled) return;
    window.dispatchEvent(new CustomEvent('native:section-menu-state', {
      detail: { view: 'client-detail', activeId: activeTab, rootId: 'overview' },
    }));
    return () => { window.dispatchEvent(new CustomEvent('native:section-menu-state', { detail: null })); };
  }, [enabled, activeTab]);
  useEffect(() => {
    if (!enabled) return;
    const navigate = (event: Event) => {
      const section = (event as CustomEvent<{ section?: string }>).detail?.section;
      if (WORKSPACE_NATIVE_SECTIONS.some(item => item.id === section)) onSection(section!);
    };
    window.addEventListener('workspace-native:section-change', navigate);
    window.addEventListener('workspace-native:close', onClose);
    return () => {
      window.removeEventListener('workspace-native:section-change', navigate);
      window.removeEventListener('workspace-native:close', onClose);
    };
  }, [enabled, onSection, onClose]);
  return enabled;
}
